module.exports = __webpack_public_path__ + "media/images/avatar-1325a83de8326e98d68839d8ec09e829.jpg";